export enum NodeContentAlignment {
  Center = 0,
  Left = 1,
  Right = 2,
}
